import {enable404ResponseState} from "@pg-mono/response-state";

import {IAppDispatch, IRootState} from "../../store/store";
import {selectGetIsUserAuthenticated} from "../../user/utils/select_get_is_user_authenticated";
import {selectUserProfileData} from "../../user/utils/select_user_profile_data";
import {isEmailDomainAllowed} from "../utils/is_email_domain_allowed";

export function semanticSearchAction() {
    return async (dispatch: IAppDispatch, getState: () => IRootState) => {
        const isAuthenticated = selectGetIsUserAuthenticated(getState());

        if (!isAuthenticated) {
            dispatch(enable404ResponseState());

            return false;
        }

        const profile = selectUserProfileData(getState());

        if (profile && !isEmailDomainAllowed(profile.email)) {
            dispatch(enable404ResponseState());

            return false;
        }
    };
}
import {enable404ResponseState} from "@pg-mono/response-state";

import {IAppDispatch, IRootState} from "../../store/store";
import {selectGetIsUserAuthenticated} from "../../user/utils/select_get_is_user_authenticated";
import {selectUserProfileData} from "../../user/utils/select_user_profile_data";
import {isEmailDomainAllowed} from "../utils/is_email_domain_allowed";

export function semanticSearchAction() {
    return async (dispatch: IAppDispatch, getState: () => IRootState) => {
        const isAuthenticated = selectGetIsUserAuthenticated(getState());

        if (!isAuthenticated) {
            dispatch(enable404ResponseState());

            return false;
        }

        const profile = selectUserProfileData(getState());

        if (profile && !isEmailDomainAllowed(profile.email)) {
            dispatch(enable404ResponseState());

            return false;
        }
    };
}
